var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "corporation" }, [
    _c(
      "div",
      { staticClass: "scroll" },
      [
        _c("contents-header", {
          attrs: { "bg-type": true, title: "MCOP-01-01-03-01" }
        }),
        _c(
          "article",
          { staticClass: "contents" },
          [
            _vm.siteCode === _vm.$config.SITECODE_OGAUC ||
            _vm.siteCode === _vm.$config.SITECODE_OGIND
              ? [
                  _c("tab", {
                    ref: "perInfoTab",
                    attrs: {
                      "css-type": "type3",
                      "title-list": ["MCOP-01-01-03-02"]
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "0",
                          fn: function() {
                            return [
                              _c("corporationInfoTab1", {
                                ref: "tab1",
                                attrs: { data: _vm.perInfo },
                                on: {
                                  "update:data": function($event) {
                                    _vm.perInfo = $event
                                  }
                                }
                              })
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      3908775851
                    )
                  })
                ]
              : [
                  _c("tab", {
                    ref: "perInfoTab",
                    attrs: {
                      "css-type": "type3",
                      "title-list": [
                        "MCOP-01-01-03-02",
                        "MCOP-01-01-03-03",
                        "MCOP-01-01-03-04"
                      ]
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "0",
                        fn: function() {
                          return [
                            _c("corporationInfoTab1", {
                              ref: "tab1",
                              attrs: { data: _vm.perInfo },
                              on: {
                                "update:data": function($event) {
                                  _vm.perInfo = $event
                                }
                              }
                            })
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "1",
                        fn: function() {
                          return [
                            _c("corporationInfoTab2", {
                              ref: "tab2",
                              attrs: { data: _vm.perInfo },
                              on: {
                                "update:data": function($event) {
                                  _vm.perInfo = $event
                                }
                              }
                            })
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "2",
                        fn: function() {
                          return [
                            _c("corporationInfoTab3", {
                              ref: "tab3",
                              attrs: { data: _vm.perInfo },
                              on: {
                                "update:data": function($event) {
                                  _vm.perInfo = $event
                                }
                              }
                            })
                          ]
                        },
                        proxy: true
                      }
                    ])
                  })
                ]
          ],
          2
        )
      ],
      1
    ),
    _c("div", { staticClass: "btn-area--full fixed" }, [
      _c(
        "button",
        { staticClass: "btn md gray", on: { click: _vm.goPrevStep } },
        [_vm._v(_vm._s(/*취소*/ _vm.$t("MCOM-0000002")))]
      ),
      _c(
        "button",
        { staticClass: "btn md normal", on: { click: _vm.goNextStep } },
        [_vm._v(_vm._s(/*수정*/ _vm.$t("MCOP-01-01-03-14")))]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }